import { render, staticRenderFns } from "./course6.vue?vue&type=template&id=6c6e13ff&scoped=true&"
import script from "./course6.vue?vue&type=script&setup=true&lang=js&"
export * from "./course6.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./course6.vue?vue&type=style&index=0&id=6c6e13ff&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6e13ff",
  null
  
)

export default component.exports